export default __webpack_public_path__ + "static/media/coupons.1ec63c8f.png";